//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Toggle2 from '~/components/Toggle2.vue';

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    sectionKey: {
      type: String,
      required: true,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Toggle2,
  },
  data() {
    return {
      inputValue: '',
      enterPressed: false,
      disabled: false,
      invalid: false,
    };
  },
  mounted() {
    this.inputValue = this.value ? this.value.value : '';
  },
  destroyed() {
    // this.saveValue();
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    setDisabledValue(disabled) {
      if (disabled) {
        this.inputValue = this.props.disabledValue;
      } else {
        this.inputValue = '';
      }
      this.saveValue();
    },
    saveValue() {
      let value = this.inputValue?.trim() || '';
      if (this.props?.validator) {
        const res = this.props.validator(this.inputValue?.trim());
        if (!res.valid) {
          this.invalid = true;
          this.$emit('save', {
            focusNext: this.enterPressed,
            key: this.sectionKey,
            value: null,
          });
          return;
        }
        this.invalid = false;
        this.inputValue = res.value;
        value = res.value;
      }
      this.$emit('save', {
        focusNext: this.enterPressed,
        key: this.sectionKey,
        value: {
          textValue: value + '',
          value,
        },
      });
      this.enterPressed = false;
    },
  },
};
